import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-32c948e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-lg-flex w-100" }
const _hoisted_2 = { class: "flex-none w-100" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search me-2 mb-2" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["placeholder"]

import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBox',
  props: {
	value: String,
	disablekeyup: Boolean,
	nopill: Boolean,
	noborder: Boolean,
	bottomborder: Boolean
},
  emits: ['doSearch', 'clear'],
  setup(__props, { emit: __emit }) {

const search = ref(null);

const props = __props

const emit = __emit;

onMounted(
	async () => {
		if (props.value) {
			search.value = props.value;
		}
	});

const doKeySearch = () => {
	if (!props.disablekeyup) emit('doSearch', search.value);
}

const doSearch = () => {
	emit('doSearch', search.value);
}

const doClear = () => {
	if (!search.value.length) emit('clear');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["input-group input-group-sm input-group-inline", [ { 'rounded-pill' : !__props.nopill }, { 'borderbottom' : __props.bottomborder } ]]),
        style: _normalizeStyle([ __props.noborder ? { 'box-shadow' : 'none' } : {} ])
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["input-group-text", [{ 'rounded-start-pill' : !__props.nopill }, { 'border-0' : __props.noborder }]])
        }, _hoisted_4, 2),
        _withDirectives(_createElementVNode("input", {
          type: "search",
          onKeyup: [
            doKeySearch,
            _withKeys(doSearch, ["enter"])
          ],
          onSearch: doClear,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          class: _normalizeClass(["form-control ps-0 sform-control", [{ 'rounded-end-pill' : !__props.nopill }, { 'border-0' : __props.noborder }]]),
          placeholder: _ctx.$t('common.search', 'Search'),
          "aria-label": "Search"
        }, null, 42, _hoisted_5), [
          [_vModelText, search.value]
        ])
      ], 6)
    ])
  ]))
}
}

})